var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isZero === true)?_c('span',{staticStyle:{"color":"#777"}},[_vm._v(_vm._s(_vm.value)+" h")]):_c('span',[_vm._v(_vm._s(_vm.value)+" h")])
}
var staticRenderFns = []

export { render, staticRenderFns }